// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _permissionsGroupMap = {
  Home: "Home",
  DispositiviRead: "Dispositivi",
  DispositiviReadAll: "Dispositivi",
  DispositiviUpdateTrasferimenti: "Dispositivi",
  DispositivoCreate: "Dispositivi",
  DispositivoUpdate: "Dispositivi",
  DispositivoGeneraCertificato: "Dispositivi",
  DispositivoDelete: "Dispositivi",
  DispositiviReadManutenzioni: "Manutenzioni",
  DispositiviUpdateManutenzioni: "Manutenzioni",
  DispositivoRegistriRead: "Dispositivi - Registri",
  DispositivoRegistriWrite: "Dispositivi - Registri",
  DispositiviDatiStoriciRead: "Dispositivi - Dati",
  DispositiviDatiStoriciReadAll: "Dispositivi - Dati",
  DispositiviAlertValuesEdit: "Dispositivi - Alerts",
  DispositiviAlertInternalUserOptionsEdit: "Dispositivi - Alerts",
  DispositiviUpdateReminders: "Dispositivi - Alerts",
  AziendeReadAll: "Aziende",
  AziendeRead: "Aziende",
  AziendaRead: "Aziende",
  AziendaCreate: "Aziende",
  AziendaUpdate: "Aziende",
  AziendaEdit: "Aziende",
  AziendaDelete: "Aziende",
  ContenitoriRead: "Centrali",
  ContenitoriReadAll: "Centrali",
  ContenitoreCreate: "Centrali",
  ContenitoreUpdate: "Centrali",
  ContenitoreUpdateAlloggiamentiFiltro: "Centrali",
  ContenitoreUpdateStoricoFiltri: "Centrali",
  ContenitoreUpdateStoricoOlio: "Centrali",
  ContenitoreUpdateReminders: "Centrali",
  ContenitoreUpdateBonifica: "Centrali",
  ContenitoreUpdateAnalisi: "Centrali",
  ContenitoreUpdateFiltrazioni: "Centrali",
  ContenitoreUpdateImmagini: "Centrali",
  ContenitoreDelete: "Centrali",
  GatewayRead: "Gateway",
  GatewayReadAll: "Gateway",
  GatewayCreate: "Gateway",
  GatewayUpdate: "Gateway",
  GatewayDelete: "Gateway",
  RipetitoreRead: "Ripetitore",
  RipetitoreReadAll: "Ripetitore",
  RipetitoreCreate: "Ripetitori",
  RipetitoreUpdate: "Ripetitori",
  RipetitoreDelete: "Ripetitori",
  GrafoRead: "Grafo",
  GrafoUpdate: "Grafo",
  TrasferimentiChange: "Trasferimenti",
  ConnessioneGatewayChange: "ConnessioneGateway",
  UsersInterniRead: "Users",
  UsersEsterniRead: "Users",
  UsersInterniChange: "Users",
  UsersEsterniChange: "Users",
  ModelliFiltroChange: "Dizionari",
  ModelliOlioChange: "Dizionari",
  ModelliGatewayChange: "Dizionari",
  DescrizioniBonificaChange: "Dizionari",
  DescrizioniManutenzioneChange: "Dizionari",
  ModelliDispositivoChange: "ModelliDispositivo",
  NodoIconeChange: "Dizionari",
  FileUpload: "File",
  AnalisiListaReadAll: "Analisi",
  AnalisiListaRead: "Analisi",
  FiltrazioniListaReadAll: "Filtrazioni",
  FiltrazioniListaRead: "Filtrazioni",
  BonificheListaReadAll: "Bonifiche",
  BonificheListaRead: "Bonifiche",
  CalendarioInterventiRead: "Calendario",
  CalendarioTrasferimentiRead: "Calendario",
  RuoliPermessiRead: "RuoliPermessi",
  RuoliPermessiUpdate: "RuoliPermessi",
  RichiestePreventivoRead: "RichiestePreventivo",
  RichiestePreventivoReadAll: "RichiestePreventivo",
  RichiestePreventivoUpdate: "RichiestePreventivo",
  RichiestePreventivoDelete: "RichiestePreventivo",
} as const;
